// extracted by mini-css-extract-plugin
export default {"capLabel":"IncentiveType_capLabel__IvjIx","valueInputWrapper":"IncentiveType_valueInputWrapper__PNXSp","fixed":"IncentiveType_fixed__wEuZ1","percent":"IncentiveType_percent__gE3if"};